import React from "react";
import PropTypes from "prop-types";
import ErrorMessage from "../partials/error";
import FieldLabel from "../../../components/label";
import OtpInput from "../../../components/otp";
import CallToAction from "../partials/cta";
import { withStyles } from "@mui/styles";
import { Box } from "@mui/material";
import { useStyles } from "../indexFormStyles";

const AadhaarOtpForm = ({
  classes: { containerButton, formGroup },
  errorMessage,
  errors,
  form,
  handleResendOtp,
  isFormSubmitted,
  setFormState,
  onSubmit,
}) => {
  return (
    <form noValidate autoComplete="off" onSubmit={onSubmit}>
      <Box className={formGroup}>
        <FieldLabel label={"OTP*"} />
        <OtpInput
          changeNumber={true}
          isFormSubmitted={isFormSubmitted}
          onChangeNumberClick={() => {}}
          otp={form.otp}
          otpCallBack={(otp) => setFormState("otp", otp)}
          resendOtp={handleResendOtp}
          buttonText={"Retry"}
        />
      </Box>

      <ErrorMessage errors={errors} />

      <Box
        className={containerButton}
        justifyContent="center"
        alignContent="center"
      >
        <CallToAction
          buttonType={"submit"}
          errorMessage={errorMessage}
          form={form}
          isFormSubmitted={isFormSubmitted}
          text={"Verify OTP"}
          handleClick={() => {}}
          marginTopClass={"marginTop10"}
          isDisabled={
            isFormSubmitted ||
            !form.otp ||
            errorMessage.otp ||
            form.otp.length !== 6
          }
        />
      </Box>
    </form>
  );
};

AadhaarOtpForm.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(useStyles, { withTheme: true })(AadhaarOtpForm);
